import type { GenerationJob } from "./dreams";

export const ACTIVE_GENERATION_STATUSES = new Set(["queued", "generating", "uncertain"]);

// Nothing on the backend advances a generation on its own — there is no
// scheduler, and /refresh is what actually polls Vertex AI. So while a job is
// active the Studio has to keep asking, or a job that finishes after the admin
// stops clicking stays "queued" forever, holding its dream_generation_locks
// document and blocking that Dream from ever generating again.
export const POLL_INTERVAL_MS = 10_000;
export const MAX_POLL_INTERVAL_MS = 120_000;

// Mirrors ABANDONABLE_QUEUED_AFTER_SECONDS in server/main.py. A job that never
// left "queued" holds its Dream's lock forever; abandoning is the only escape,
// and the backend re-checks this bound, so the button is a hint, not the gate.
export const STALE_QUEUED_AFTER_MS = 60 * 60 * 1000;

export function isAbandonable(job: GenerationJob): boolean {
  if (job.status === "uncertain") return true;
  if (job.status !== "queued") return false;
  const updatedAt = Date.parse(job.updated_at);
  return Number.isFinite(updatedAt) && Date.now() - updatedAt >= STALE_QUEUED_AFTER_MS;
}

export function statusMessageFor(job: GenerationJob): string {
  if (job.status === "simulated") return "Simulation complete. It created no video and used no credits.";
  if (job.status === "ready") return "Dream video is ready for review and publishing.";
  if (job.status === "failed") return job.error ?? "Generation failed.";
  if (job.status === "uncertain") return "Vertex acceptance is still unknown. Check again later or abandon carefully.";
  return "Generation is now processing.";
}
